"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MarginBalancesTableContainer = require("./MarginBalancesTableContainer");
Object.keys(_MarginBalancesTableContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MarginBalancesTableContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MarginBalancesTableContainer[key];
    }
  });
});
var _MarginBalancesTable = require("./MarginBalancesTable");
Object.keys(_MarginBalancesTable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MarginBalancesTable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MarginBalancesTable[key];
    }
  });
});
var _SpotBalancesTableContainer = require("./SpotBalancesTableContainer");
Object.keys(_SpotBalancesTableContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SpotBalancesTableContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SpotBalancesTableContainer[key];
    }
  });
});
var _SpotBalancesTable = require("./SpotBalancesTable");
Object.keys(_SpotBalancesTable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SpotBalancesTable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SpotBalancesTable[key];
    }
  });
});
var _FuturesBalancesTablesWrapper = require("./FuturesBalancesTablesWrapper");
Object.keys(_FuturesBalancesTablesWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FuturesBalancesTablesWrapper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FuturesBalancesTablesWrapper[key];
    }
  });
});